import React from "react";

export default function ModuleAskBar({ module, label, placeholder }) {
  const openAsk = () => window.dispatchEvent(new CustomEvent("hm_open_ask", {
    detail: { context: { module, module_label: label, surface: label } },
  }));

  return <div className="fd-food-askbar" aria-label={`Ask HouseMind about ${label}`}>
    <input
      className="fd-food-askbar__input"
      readOnly
      placeholder={`✦ ${placeholder || `Ask about ${label.toLowerCase()}…`}`}
      onFocus={openAsk}
      onClick={openAsk}
    />
    <button className="fd-food-askbar__button" type="button" onClick={openAsk}>✦ Ask</button>
  </div>;
}
